module.exports = __webpack_public_path__ + "static/img/about_cooperate_03_zh.db142e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_cooperate_03_zh.png
// module id = p/fl
// module chunks = 34